import {useEffect, useState} from 'react';

import IServerIncident from './ServerIncident/IServerIncident';
import {getServerIncidentDurationSeconds, isServerIncidentOpen} from '../lib/serverIncidentHelper';

export function useServerIncidentDuration(incident: IServerIncident): number {
    const isOpen = isServerIncidentOpen(incident);
    const [seconds, setSeconds] = useState(() => getServerIncidentDurationSeconds(incident));

    useEffect(() => {
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setSeconds(getServerIncidentDurationSeconds(incident));

        if (!isOpen) return;

        const timer = setInterval(() => {
            setSeconds(getServerIncidentDurationSeconds(incident));
        }, 1000);

        return () => clearInterval(timer);
    }, [incident, isOpen]);

    return seconds;
}
